// Rimborsi senza storno in Eureka: l'allarme che il 18114942-A non ha avuto.
//
// La SF 485 è rimasta tutta nei corrispettivi per tre mesi perché lo storno era
// stato escluso, e un'esclusione nella pagina non si vede più. Questo riquadro
// non si chiude e non si archivia: sparisce da solo quando lo storno esiste in
// Eureka (il backend lo ricalcola a ogni caricamento). Stessa lista della
// campanella e dello Slack delle 16.
import type { StornoScoperto } from "../types";

function euro(importo: string): string {
  const n = Number(importo);
  return Number.isFinite(n) && importo !== ""
    ? n.toLocaleString("it-IT", { style: "currency", currency: "EUR" })
    : "";
}

export function StorniScoperti({
  righe,
  onApri,
}: {
  righe: StornoScoperto[];
  /** Porta la lista sull'ordine, dove ci sono i tasti per sistemarlo. */
  onApri: (ordine: string) => void;
}) {
  if (righe.length === 0) return null;
  const n = righe.length;
  return (
    <section
      role="alert"
      aria-labelledby="storni-scoperti-titolo"
      className="mb-4 rounded-lg border border-red/40 bg-red-soft px-4 py-3 max-md:px-3"
    >
      <h2 id="storni-scoperti-titolo" className="text-[14px] font-bold text-ink max-md:text-[15px]">
        {n} {n === 1 ? "rimborso" : "rimborsi"} senza storno in Eureka
      </h2>
      <p className="mt-0.5 text-[12.5px] text-ink max-md:text-[14px]">
        Il cliente ha avuto i soldi indietro, ma il documento è ancora tutto nei corrispettivi.
        Emetti lo storno o, se esiste già in Eureka, collegalo con «Segna fatta».
      </p>
      <ul className="mt-2.5 divide-y divide-red/20 border-t border-red/20">
        {righe.map((r) => (
          <li
            key={r.proposal_id}
            className="flex items-center gap-4 py-2 max-md:flex-wrap max-md:gap-x-3 max-md:gap-y-1"
          >
            <span className="w-[150px] shrink-0 tabular-nums text-[12.5px] font-semibold text-ink max-md:w-auto">
              {r.ordine}
            </span>
            <span className="w-[90px] shrink-0 text-[12.5px] font-semibold text-ink max-md:w-auto">
              {r.documento}
            </span>
            <span className="min-w-0 flex-1 truncate text-[12.5px] text-ink max-md:basis-full max-md:order-last">
              {r.cliente}
              {r.importo ? <span className="tabular-nums"> · {euro(r.importo)}</span> : null}
              <span className="text-red"> · {r.motivo}</span>
            </span>
            <button
              type="button"
              onClick={() => onApri(r.ordine)}
              className="ml-auto shrink-0 rounded-md bg-ink px-3 py-1.5 text-[12px] font-semibold text-on-ink transition-[filter] duration-150 hover:brightness-125 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink max-md:h-10 max-md:px-4 max-md:text-[14px]"
            >
              Sistema
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
